<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-container :fluid="true" class="ma-0 pa-0" v-if="loading">
    <v-row class="text-white bg-yellow-darken-3 pa-3 mt-0">
      <router-link to="/">
        <v-icon color="white" icon="mdi-less-than" size="x-large" class="pr-5 pl-5"></v-icon>
      </router-link>
      <v-icon color="white" icon="mdi-shield-lock" size="x-large" class="pr-5 pl-5"></v-icon>
      <h3 class="pt-1">{{ localeKeys.strings.LANDING_PRIVACY }}</h3>
    </v-row>
    <v-row>
      <v-col offset-lg="2" lg="8" offset="1" cols="10" class="pl-0">
        <p class="text-h6 font-weight-bold">{{ localeKeys.strings.PRIVACY_HEADER }}</p>
        <p class="mt-2">{{ localeKeys.strings.PRIVACY_IMPORTANT }}</p>
        <p class="mt-2">{{ localeKeys.strings.PRIVACY_VALUED }}</p>
        <p class="mt-2">
          {{ localeKeys.strings.PRIVACY_FURTHER }}
          <a href="https://pikpok.com/privacy/" target="_blank" style="text-decoration: underline;">
            {{ localeKeys.strings.SUPPORT_PRIVACY_POLICY }}
          </a>
        </p>
        <p class="mt-5 text-h6 font-weight-bold">{{ localeKeys.strings.PRIVACY_TOOLS }}</p>
      </v-col>
    </v-row>
    <!-- Privacy Form Link -->
    <router-link to="/privacyform" style="text-decoration: none; color: inherit;">
      <v-row class="mt-5">
        <v-col offset-lg="2" lg="8" offset="1" cols="10"
               class="border-solid text-yellow-darken-3 font-weight-medium"
               style="border-color: #F9A825">
          <v-row>
            <v-col cols="10" class="pl-0 pr-0">
              <v-icon color="yellow-darken-3" icon="mdi-trash-can-outline" size="x-large" class="pl-2"></v-icon>
              <span class="pl-2 text-sm-h6">{{ localeKeys.strings.PRIVACY_ERASE }}</span>
            </v-col>
            <v-col cols="2" align="right" class="pl-0">
              <v-icon color="yellow-darken-3" icon="mdi-greater-than" size="x-large"></v-icon>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </router-link>
    <!-- Consent Form Link -->
    <router-link to="/consentform" style="text-decoration: none; color: inherit;">
      <v-row class="mt-10 mb-10">
        <v-col offset-lg="2" lg="8" offset="1" cols="10"
               class="border-solid text-yellow-darken-3 font-weight-medium"
               style="border-color: #F9A825">
          <v-row>
            <v-col cols="10" class="pl-0 pr-0">
              <v-icon color="yellow-darken-3" icon="mdi-pencil" size="x-large" class="pl-1"></v-icon>
              <span class="pl-2 text-sm-h6">{{ localeKeys.strings.CONSENT_LINK }}</span>
            </v-col>
            <v-col cols="2" align="right" class="pl-0">
              <v-icon color="yellow-darken-3" icon="mdi-greater-than" size="x-large"></v-icon>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </router-link>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "PrivacyComponent",
  components: {},
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...
        mapState({
          localeKeys: state => state.supportStore.localeKeys,
        }),
  },
  mounted() {
    this.getLocaleKeys().then(() => {
      this.loading = true
    })
  },
  methods: {
    ...mapActions([
      'getLocaleKeys'
    ])
  }
}
</script>